export default __webpack_public_path__ + "static/startupmag-logo-5a630e09c6cb23f94a77c6280687aa4a.png";